( function($) {
	
	/**
	 * Display Passwords
	 **/  
	$( '#toggleSetPass' ).on( 'click', function(e) {
		e.preventDefault();
		
		$( this ).toggleClass( 'fa-eye fa-eye-slash' );
		
		if( $( '#setPassword' ).attr( 'type' ) === 'password' ) {
			$( '#setPassword' ).attr( 'type', 'text' );
		} 
		
		else {
			$( '#setPassword' ).attr( 'type', 'password' );
		}
	} );

	$( "#toggleConfirmPass" ).on( 'click', function(e) {
		e.preventDefault();

		$( this ).toggleClass( "fa-eye fa-eye-slash" );
		
		if( $( "#confirmPassword" ).attr( "type" ) === "password" ) {
			$( "#confirmPassword" ).attr( "type", "text" );
		} 
		
		else {
			$( "#confirmPassword" ).attr( "type", "password" );
		}
	} );



	/**
	 * Insert passwords into hidden fields
	 */
	$( "#setPassword" ).on( "keyup", function() {
		$( '#passOne' ).val( $( this ).val() );
	} );

	$( "#confirmPassword" ).on( "keyup", function() {
		$( '#passTwo' ).val( $( this ).val() );
	} );



/**
 * Ajax function for password submission
 * 
 * @typedef {Object} PasswordPayload
 * 
 * @property {string} action
 * @property {string} confirmPassword
 * @property {string} password
 * @property {string} token
 * 
 * @param {jQuery.Event} e Submit click event
 * @param {jQuery} el Button element wrapped as a jQuery object
 * @param {PasswordPayload} data Payload sent to the WP Ajax endpoint
 */
	function submit_password_ajax( e, el, data ) {
		e.preventDefault();
		
		const message = document.getElementById( 'errorMessage' );

		message.textContent = '';
		message.className 	= 'error-message';

		$.ajax( {
			type: 'post',
			dataType: 'JSON',
			url: '/wp-admin/admin-ajax.php',
			data: data,

			beforeSend: function( xhr ) {
				el.hide();
			},
			
			success: function( data ) {
				console.log( 'data::', data );

				const success_codes = [ 200, 201, 204 ];

				if( success_codes.includes( data.code_response ) ) {
					// Password set successfully.  Send them to the dashboard.
					window.location.href = window.location.origin + '/portal/dashboard/?member=welcome';
				}

				else {
					el.show();
					$( '.payment-loader-container' ).addClass( 'uk-hidden' );

					message.textContent = data.message;
					message.className 	= 'error';
				}
			},

			error: function( res ) {
				el.show();
				$( '.payment-loader-container' ).addClass( 'uk-hidden' );

				message.textContent = 'There was an error in your submission.  Please contact support.';
				message.className 	= 'error';

				console.log( 'res::', res );
				console.log( 'responseText::', res.responseText );
			}
		} );
	}



	/**
	 * Validate + submit password
	 */
	$( "#submitConfirmPassword" ).on( 'click', function(e) {
		e.preventDefault();
	
		const token 	= document.getElementById( 'token' ).value;
		const pw1 		= document.getElementById( 'passOne' ).value;
		const pw2		  = document.getElementById( 'passTwo' ).value;
		const message = document.getElementById( 'errorMessage' );
		const specialCharPattern = /[^A-Za-z0-9]/;

		// Reset message
		message.textContent = '';
		message.className 	= 'error-message';
		
		$( '.payment-loader-container' ).removeClass( 'uk-hidden' );

		// Check password length
		if( pw1.length < 8 ) {
			message.textContent = 'Password must be at least 8 characters long.';
			message.className 	= 'error';

			$( '.payment-loader-container' ).addClass( 'uk-hidden' );
			
			return;
		}

		// Check for special character (not a letter or number)
		if( !specialCharPattern.test( pw1 ) ) {
			message.textContent = 'Password must contain at least one special character.';
			message.className 	= 'error';

			$( '.payment-loader-container' ).addClass( 'uk-hidden' );

			return;
		}

		// Check if passwords match
		if( pw1 !== pw2 ) {
			message.textContent = 'Passwords do not match.';
			message.className = 'error';

			$( '.payment-loader-container' ).addClass( 'uk-hidden' );

			return;
		}

		let	data = {
			'action': "set_user_portal_password",	
			"confirmPassword": pw2,
			"password": pw1,
			"token": token
		};

		submit_password_ajax( e, $( this ), data );
	} );
} )( jQuery );
